import Popper from '@material-ui/core/Popper';
import { makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import theme from 'style/theme';
import styled from 'styled-components';

export const useResidentListingStyles = makeStyles(() => ({
  root: {
    fontSize: 14,
  },
  button: {
    textAlign: 'left',
    paddingBottom: 0,
    marginBottom: 8,
    color: theme.colors.eastBay,
    fontWeight: 700,
    justifyContent: 'flex-start',
    '&:hover,&:focus': {
      color: theme.colors.eastBay,
    },
    '& span': {
      width: '100%',
    },
    '& h4': {
      textAlign: 'left',
      fontSize: 18,
      margin: 0,
      padding: 0,
    },
  },
  popper: {
    border: `1px solid ${theme.colors.shadowBorderGrey}`,
    boxShadow: `0 3px 12px ${theme.colors.shadowBorderGrey}`,
    width: 300,
    zIndex: 1,
    fontSize: 14,
    color: theme.colors.eastBay,
    backgroundColor: theme.colors.white,
    borderRadius: 8,
    fontFamily: 'Popins',
  },
  inputBase: {
    padding: 10,
    width: '100%',
    // borderBottom: '1px solid #dfe2e5',
    '& input': {
      borderRadius: 8,
      backgroundColor: theme.colors.white,
      padding: '8px 25px',
      border: `1px solid ${theme.colors.ghost}`,
      fontSize: 14,
      '&:focus': {
        boxShadow: `${theme.colors.mainlyblue} 0 0 0 0.2rem`,
        borderColor: theme.colors.malibu06,
      },
    },
  },
  paper: {
    margin: 0,
    color: theme.colors.comet,
    fontSize: 14,
  },
  option: {
    minHeight: 'auto',
    alignItems: 'flex-start',
    padding: 8,
    '&[aria-selected="true"]': {
      backgroundColor: 'transparent',
      zIndex: 2,
    },
  },
  popperDisablePortal: {
    position: 'relative',
    zIndex: 1,
  },
  iconSelected: {
    width: 17,
    height: 17,
    marginRight: 5,
    marginLeft: -2,
  },
  color: {
    width: 14,
    height: 14,
    flexShrink: 0,
    borderRadius: 3,
    marginRight: 8,
    marginTop: 2,
  },
  text: {
    flexGrow: 1,
  },
  close: {
    opacity: 0.6,
    width: 18,
    height: 18,
  },
}));

export const SearchWrapper = styled.div`
  position: relative;
`;

export const InputSearchIcon = styled(SearchIcon)`
  position: absolute;
  left: 15px;
  top: 35%;
`;

export const PopperWrapperStyled = styled(Popper)`
  box-shadow: 0 4px 8px rgb(0 0 0 / 12%);
  max-height: inherit;
  z-index: 110;
  && .MuiAutocomplete-listbox {
    border-radius: 8px;
    .MuiAutocomplete-option {
      background-color: transparent;
    }
  }
`;
// export const Option = styled.li`
//   display: block;
//   color: #68686a;
//   cursor: pointer;
//   font-weight: 500;
//   font-size: 14px;
//   line-height: 21px;
//   padding: 8px;
//   transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease,
//     box-shadow 0.15s ease;
//   &:hover {
//     background: rgba(92, 171, 221, 0.1);
//   }
// `;
export const Option = styled.li`
  color: #68686a;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  min-height: 37px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  > div {
    font-family: Poppins, Helvetica, 'sans-serif';
    margin-left: 8px;
  }

  &:hover {
    background: rgba(92, 171, 221, 0.1);
  }
`;
